export enum RoutesPldFullEnum {
    PURPOSE = 'pld-proposito-full' as any,
    MONEY = 'pld-saldo-promedio-full' as any,
    CREDITS = 'pld-acreditaciones-mensuales-full' as any,
}
